import { Stack, Text } from "@mantine/core"
import { Button, ErrorBox } from "@tfg/ui"
import type { AxiosError } from "axios"
import { useTranslation } from "react-i18next"

import { LoginTextInput } from "~/pages/Auth/components/LoginTextInput"

type MagicLinkStepProps = {
  email: string
  isSendingMagicLink: boolean
  error: AxiosError | null
  onSendMagicLink: () => Promise<void>
  onSetPassword: () => void
  onBack: () => void
}

export const MagicLinkStep = ({
  email,
  isSendingMagicLink,
  error,
  onSendMagicLink,
  onSetPassword,
  onBack,
}: MagicLinkStepProps) => {
  const { t } = useTranslation("account")

  return (
    <Stack w="100%" gap="var(--tfg-molecule-padding-y)">
      <ErrorBox error={error} />
      <Text fw={500} style={{ textAlign: "center" }}>
        {t("login.magicLink.step.title")}
      </Text>
      <LoginTextInput
        name="email"
        type="email"
        required
        readOnly
        value={email}
        data-testid="login-email"
        label={t("login.labels.email")}
        placeholder={t("login.placeholders.email")}
      />
      <Button
        size="sm"
        fullWidth={true}
        loading={isSendingMagicLink}
        disabled={!email || isSendingMagicLink}
        data-testid="login-send-magic-link"
        onClick={onSendMagicLink}
      >
        {t("login.magicLink.step.sendLink")}
      </Button>
      <Button
        size="sm"
        fullWidth={true}
        variant="secondary"
        disabled={isSendingMagicLink}
        data-testid="login-set-password"
        onClick={onSetPassword}
      >
        {t("login.magicLink.step.setPassword")}
      </Button>
      <Button
        size="sm"
        fullWidth={true}
        variant="tertiary"
        disabled={isSendingMagicLink}
        data-testid="login-magic-link-back"
        onClick={onBack}
      >
        {t("login.magicLink.step.back")}
      </Button>
    </Stack>
  )
}
